<div [formGroup]="ticketForm" class="p-6 relative border-y border-gray-300" [class.bg-white]="isOdd" [class.bg-slate-100]="isEven">
    <div class="flex gap-5 justify-evenly">
        <div class="w-full">
            <div class="flex flex-col mb-3">
                <label for="ticketDescription">Description</label>
                <input formControlName="description" type="text" id="ticketDescription">
            </div>
            <div class="flex flex-col mb-3">
                <label for="ticketRestriction">Restrictions</label>
                <input formControlName="restrictions" type="text" id="ticketRestriction">
            </div>
            <div class="flex flex-col mb-3">
                <label for="caterer">Caterer</label>
                <input formControlName="caterer" type="text" id="caterer">
            </div>
        </div>
        <div class="w-full">
            <div class="flex gap-3 mb-3">
                <div class="flex flex-col w-full">
                    <label for="availableFrom">Available From</label>
                    <input type="datetime-local" id="availableFrom" formControlName="availableFrom" />
                </div>
                <div class="flex flex-col w-full">
                    <label for="availableTo">Available To</label>
                    <input type="datetime-local" id="availableTo" formControlName="availableTo" />
                </div>
            </div>
            <div class="flex gap-3 mb-3">
                <div class="flex flex-col">
                    <label for="cost">Cost</label>
                    <p-inputnumber mode="currency" currency="GBP" locale="en-GB" formControlName="cost" />
                </div> 
                <div class="flex flex-col">
                    <label for="available">Available</label>
                    <p-toggleswitch class="mx-auto mt-1" formControlName="available" />
                </div>    
                <div class="flex justify-end gap-4 mt-4 w-full">
                    <button class="outline-button" (click)="closeClicked.emit()">Cancel</button>
                    <button class="primaryButton" (click)="saveChanges()">Save</button>
                </div>   
            </div>
        </div>
    </div>
</div>